import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'umkt-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() isOpen = false;
  @Input() showHeader = true;
  @Input() showFooter = true;
  @Output() modalClose = new EventEmitter<void>();

  closeModal(): void {
    this.modalClose.emit();
  }
} 